import { VisitorVariations } from '@src/container/handleIframeMessage/types';
import { FS_FORCED_VARIATIONS, FS_VARIATIONS_FORCED_ALLOCATION, FS_VARIATIONS_FORCED_UNALLOCATION } from '../constants';
import { FsVariationToForce } from '../type';

function getStoredVariations(storageKey: string): Record<string, FsVariationToForce> {
  const storedData = sessionStorage.getItem(storageKey);
  try {
    return JSON.parse(storedData || '{}');
  } catch (error) {
    console.error(`Error parsing stored variations from ${storageKey}:`, error);
    return {};
  }
}

function saveStoredVariations(storageKey: string, variationsToForce: Record<string, FsVariationToForce>): void {
  const existingVariations = getStoredVariations(storageKey);
  const updatedVariations = { ...existingVariations, ...variationsToForce };
  sessionStorage.setItem(storageKey, JSON.stringify(updatedVariations));
}

export function saveForcedVariations(variationsToForce: Record<string, FsVariationToForce>): void {
  saveStoredVariations(FS_FORCED_VARIATIONS, variationsToForce);
}

export function removeForcedVariations(campaignIdsToRemove: string[]): void {
  const existingVariations = getStoredVariations(FS_FORCED_VARIATIONS);
  campaignIdsToRemove.forEach((key) => {
    delete existingVariations[key];
  });
  sessionStorage.setItem(FS_FORCED_VARIATIONS, JSON.stringify(existingVariations));
}

export function saveVariationsForcedAllocation(variationsToForce: Record<string, FsVariationToForce>): void {
  sessionStorage.setItem(FS_VARIATIONS_FORCED_ALLOCATION, JSON.stringify(variationsToForce));
}

export function saveVariationsForcedUnallocation(variationsToForce: Record<string, FsVariationToForce>): void {
  sessionStorage.setItem(FS_VARIATIONS_FORCED_UNALLOCATION, JSON.stringify(variationsToForce));
}

export function getVariationsForcedAllocationFromStorage(): Record<string, FsVariationToForce> {
  return getStoredVariations(FS_VARIATIONS_FORCED_ALLOCATION);
}

export function getVariationsForcedUnallocationFromStorage(): Record<string, FsVariationToForce> {
  return getStoredVariations(FS_VARIATIONS_FORCED_UNALLOCATION);
}

export function getForcedVariationsFromStorage(): Record<string, FsVariationToForce> {
  return getStoredVariations(FS_FORCED_VARIATIONS);
}

export function removeForcedVariationsInStorage(): void {
  sessionStorage.removeItem(FS_FORCED_VARIATIONS);
}

export function removeVariationsForcedAllocationInStorage(): void {
  sessionStorage.removeItem(FS_VARIATIONS_FORCED_ALLOCATION);
}

export function removeVariationsForcedUnallocationInStorage(): void {
  sessionStorage.removeItem(FS_VARIATIONS_FORCED_UNALLOCATION);
}

export function validateVariationType(data: Record<string, VisitorVariations>): boolean {
  if (typeof data !== 'object' || data === null) {
    return false;
  }

  return Object.values(data).every((campaign) => {
    return (
      campaign !== null &&
      typeof campaign === 'object' &&
      typeof campaign.variationId === 'string' &&
      typeof campaign.variationGroupId === 'string' &&
      typeof campaign.campaignId === 'string'
    );
  });
}
